import React, { forwardRef } from 'react';
import Typography from '../Typography/Typography';
import { AccordionDetails, AccordionWrapper, AccordionSummary } from './Accordion.styles';
import { AccordionProps as MuiAccordionProps } from '@mui/material';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';

interface AccordionProps extends Omit<MuiAccordionProps, 'children'> {
  summary?: string;
  summaryComponents?: React.ReactNode;
  details?: React.ReactNode;
  detailsComponents?: React.ReactNode;
}

export const Accordion = forwardRef(
  ({ summary, summaryComponents, details, detailsComponents, ...props }: AccordionProps, ref): JSX.Element => {
    return (
      <AccordionWrapper disableGutters elevation={0} {...props}>
        <AccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}>
          {summary && (
            <Typography marginTop={0.25} variant="body3">
              {summary}
            </Typography>
          )}
          {summaryComponents}
        </AccordionSummary>

        <AccordionDetails>
          {details && <Typography variant="caption">{details}</Typography>}
          {detailsComponents}
        </AccordionDetails>
      </AccordionWrapper>
    );
  }
);
